import { useState } from "react";
import FileUploadField from "../../components/FileUploadField";
import FormSuccess from "../../components/FormSuccess";
import { useSubmission } from "../../utils/useSubmission";

const BLANK = {
  fullName: "", nationality: "South Korea", passportNumber: "", dateOfBirth: "",
  employerOrSponsor: "", positionRole: "", intendedStartDate: "",
  email: "", phone: "", notes: "",
};

export default function VisaRequestPage() {
  const [f, setF] = useState(BLANK);
  const [files, setFiles] = useState([]);
  const { submitting, error, setError, success, submit } = useSubmission({
    collectionName: "visaRequests", storageFolder: "visa-requests",
  });

  const set = (k, v) => setF(prev => ({ ...prev, [k]: v }));

  const onSubmit = e => {
    e.preventDefault();
    if (!f.fullName || !f.nationality || !f.email || !f.employerOrSponsor || !f.positionRole) {
      setError("Please fill in all required fields.");
      return;
    }
    submit(f, files);
  };

  if (success) {
    return (
      <section className="sec"><div className="container">
        <FormSuccess title="Visa Request Received"
          message="Thank you — your employment visa request has been received. Our team will review it and follow up by email or phone." />
      </div></section>
    );
  }

  return (
    <>
      <div className="pg-hdr">
        <h1>Employment Visa Request</h1>
        <p>For Korean nationals with a confirmed role or assignment on the Papua LNG Project.</p>
      </div>
      <section className="sec">
        <div className="container">
          <form className="form-card fade-up" onSubmit={onSubmit}>
            {error && <div className="form-err-banner">{error}</div>}

            <div className="field-row">
              <div className="field">
                <label>Full Name <span className="req">*</span></label>
                <input value={f.fullName} onChange={e => set("fullName", e.target.value)} placeholder="As shown on passport" required/>
              </div>
              <div className="field">
                <label>Nationality <span className="req">*</span></label>
                <input value={f.nationality} onChange={e => set("nationality", e.target.value)} required/>
              </div>
            </div>

            <div className="field-row">
              <div className="field">
                <label>Passport Number</label>
                <input value={f.passportNumber} onChange={e => set("passportNumber", e.target.value)}/>
              </div>
              <div className="field">
                <label>Date of Birth</label>
                <input type="date" value={f.dateOfBirth} onChange={e => set("dateOfBirth", e.target.value)}/>
              </div>
            </div>

            <div className="field">
              <label>Employer / Sponsoring Company <span className="req">*</span></label>
              <input value={f.employerOrSponsor} onChange={e => set("employerOrSponsor", e.target.value)}
                placeholder="e.g. Daewoo E&C, KCTC, or your subcontractor" required/>
            </div>

            <div className="field-row">
              <div className="field">
                <label>Position / Role <span className="req">*</span></label>
                <input value={f.positionRole} onChange={e => set("positionRole", e.target.value)} required/>
              </div>
              <div className="field">
                <label>Intended Start Date</label>
                <input type="date" value={f.intendedStartDate} onChange={e => set("intendedStartDate", e.target.value)}/>
              </div>
            </div>

            <div className="field-row">
              <div className="field">
                <label>Email <span className="req">*</span></label>
                <input type="email" value={f.email} onChange={e => set("email", e.target.value)} required/>
              </div>
              <div className="field">
                <label>Phone</label>
                <input value={f.phone} onChange={e => set("phone", e.target.value)}/>
              </div>
            </div>

            <div className="field">
              <label>Additional Notes</label>
              <textarea value={f.notes} onChange={e => set("notes", e.target.value)}
                placeholder="Anything else that would help us process your request"/>
            </div>

            <FileUploadField label="Passport Copy / Offer Letter (optional)"
              hint="Passport photo page and/or employment offer letter, PDF or image, max 10MB each"
              files={files} setFiles={setFiles} onError={setError}/>

            <button className="btn-g" style={{ width: "100%", marginTop: ".5rem" }} disabled={submitting}>
              {submitting ? "Submitting…" : "Submit Visa Request →"}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
